import styled from '@emotion/styled';

import MemoDeleteIcon from '@/assets/icons/btn_memo_delete.svg';
import MemoEditIcon from '@/assets/icons/btn_memo_edit.svg';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

export const Wrapper = styled.div(() =>
  mq({
    width: ['calc(100vw - 80px)', 'calc(100vw - 80px)', 'auto', 'auto'],
    overflow: 'hidden',
  }),
);

export const EntryRacerName = styled.div(() =>
  mq({
    fontSize: defaultTheme.font.size.m,
    fontWeight: 'bold',
    paddingBottom: defaultTheme.spacing.l,
  }),
);

export const NoteListArea = styled.div(() =>
  mq({
    borderTop: `1px solid ${defaultTheme.border.color.mediumLightGray}`,
  }),
);

export const Title = styled.div(() =>
  mq({
    color: defaultTheme.color.grayScale.dark,
    fontSize: defaultTheme.font.size.xs,
    padding: `${defaultTheme.spacing.l} 0 ${defaultTheme.spacing.s} 0`,
  }),
);

export const Content = styled.div(() =>
  mq({
    display: 'flex',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${defaultTheme.border.color.mediumLightGray}`,
    paddingBottom: defaultTheme.spacing.l,
  }),
);

export const Note = styled.div(() =>
  mq({
    fontSize: defaultTheme.font.size.s,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-all',
    marginRight: defaultTheme.spacing.xxl,
    lineHeight: defaultTheme.font.height.l,
  }),
);

export const IconArea = styled.div(() =>
  mq({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
  }),
);

const BaseButton = styled.button(() =>
  mq({
    display: 'inline-block',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    width: '20px',
    height: '20px',
    cursor: 'pointer',
    ...hoverOpacity,
  }),
);

export const Buttons = styled.div(() =>
  mq({
    display: 'grid',
    gridGap: `${defaultTheme.spacing.l}`,
    margin: `${defaultTheme.spacing.xl} auto 0 auto`,
    width: '100%',
    maxWidth: '320px',
  }),
);

export const EditButton = styled(BaseButton)(() =>
  mq({
    backgroundImage: `url(${MemoEditIcon})`,
    marginRight: defaultTheme.spacing.l,
  }),
);

export const DeleteButton = styled(BaseButton)(() =>
  mq({
    width: '17px',
    backgroundImage: `url(${MemoDeleteIcon})`,
  }),
);

export const DeleteTextArea = styled.div(() =>
  mq({
    fontSize: defaultTheme.font.size.s,
    textAlign: 'center',
    marginBottom: defaultTheme.spacing.xxl,
  }),
);

export const DeleteTitle = styled.div(() =>
  mq({
    fontWeight: 'bold',
    marginBottom: defaultTheme.spacing.s,
  }),
);

export const RaceDate = styled.time(() =>
  mq({
    marginRight: defaultTheme.spacing.s,
  }),
);

export const RaceInfo = styled.span(() =>
  mq({
    marginLeft: defaultTheme.spacing.xs,
  }),
);
